var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"reward-list-header"},[_c(_setup.CardTitle,{attrs:{"title":_setup.i18n('專屬獎賞'),"isShowSplit":true,"isEnVertical":true}},[_c('span',{staticClass:"title-content",domProps:{"innerHTML":_vm._s(_setup.titleContent)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }